import { render, staticRenderFns } from "./CustomOverlaysIndication.vue?vue&type=template&id=237c4f71&"
import script from "./CustomOverlaysIndication.vue?vue&type=script&lang=js&"
export * from "./CustomOverlaysIndication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports